export const DEFAULT_NOTIFICATION_CLOSE_TIMER = 2000
export const DEFAULT_FIRST_PAGE_PAGINATOR = 1
export const DEFAULT_OBJECTS_PER_PAGE = 10
export const DEFAULT_FIRST_ITEM_SLICE = 0
export const DEFAULT_LAST_ITEM_SLICE = 10
export const DEFAULT_SUCCESS_STATUS_CODE = 200
